const DATA_TEST_IDS = {
  securityAddNewQrDialog: 'profile__security_add-new-qr-dialog',
  securityEditQrDialog: 'profile__security_edit-qr-dialog',
  securitySecurityPage: 'profile__security_security-page',
  securityFragmentPassword: 'profile_security_security-fragment-password',
} as const;

export default DATA_TEST_IDS;
